var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mb-6"},[_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbs}}),_vm._v(" "),_c('order-settings',{attrs:{"slug":_vm.slug,"country":_vm.country,"show-fidelity-points":(+_vm.fidelityPoints)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }